import { z } from "zod";
/**
 * A metric on the wire.
 *
 * The discriminated union survives the API boundary intact. Flattening it to a
 * nullable number here would undo the whole point of AGENTS.md §1 at the one
 * place a client could still be forced to handle the absent case — and the UI
 * would go back to guessing whether `null` means zero or means unknown.
 */
export const metricValueSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("value"),
        value: z.number(),
        tier: z.enum(["observed", "modelled", "proxy"]),
        sampleSize: z.number().int().nonnegative(),
    }),
    z.object({
        kind: z.literal("insufficient_data"),
        reason: z.enum(["no_data", "too_few_samples", "no_comparison_window"]),
        /** Quantified so the UI can say "needs 28, you have 3" — never "no data". */
        required: z.number().int().nonnegative(),
        have: z.number().int().nonnegative(),
    }),
]);
export const brandCoverageSchema = z.object({
    brandId: z.string(),
    brandName: z.string(),
    coverage: metricValueSchema,
    /**
     * Sent alongside the metric so the screen can show the fraction the
     * percentage came from. A number nobody can check is a number nobody should
     * act on.
     */
    responsesMentioningBrand: z.number().int().nonnegative(),
    totalResponses: z.number().int().nonnegative(),
});
/**
 * A brand a workspace is tracking travels as `brandSchema`, defined once in
 * `brands.ts`.
 *
 * It used to be declared here as well, with the same name and one field fewer.
 * Two shapes for one thing on one wire is how a screen ends up showing coverage
 * for "GitHub" without showing that it also counted "GitHub Advanced Security"
 * — a number nobody can check.
 */
//# sourceMappingURL=metrics.js.map